import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { filterProps } from './props';
export var modifyKeys = function modifyKeys(props, modifyFn) {
  return Object.keys(props).reduce(function (acc, key) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _objectSpread2[modifyFn(key)] = props[key], _objectSpread2));
  }, {});
};
export var omitKeys = function omitKeys(props, omitProps) {
  var _omitProps;

  if (omitProps === void 0) {
    omitProps = [];
  }

  return !((_omitProps = omitProps) != null && _omitProps.length) ? props : filterProps(props, function (key) {
    return !omitProps.includes(key);
  });
};